<template>
  <div>
    <card class="card">
      <label style="color:black; font-size:18px;font-weight:bold">A. Aspetti connessi al cliente</label>
      <table class="table tablesorter" id="tabella" style="text-align: center">
        <thead>
          <tr>
            <th></th>
            <th>Fattore di rischio riscontrato</th>
            <th>Valore</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Natura Giuridica</td>
            <td style="text-align:left">
              <div class="row">
                <div class="col-11">Non congruità della natura giuridica prescelta in relazione all’attività svolta e alle sue dimensioni<hr></div>
                <div class="col-1"><input type="checkbox" v-model="a1_1" v-on:change="updateValue('a1_1')"/></div>
              </div>
              <div class="row">
                <div class="col-11">Articolazione giuridica, complessità e opacità della struttura volte ad ostacolare l’identificazione del titolare effettivo o l’attività concretamente svolta<hr></div>
                <div class="col-1"><input type="checkbox" v-model="a1_2" v-on:change="updateValue('a1_2')"/></div>
              </div>
              <div class="row">
                <div class="col-11">Partecipazione di persone politicamente esposte (cliente, esecutore, titolare effettivo)<hr></div>
                <div class="col-1"> <input type="checkbox" v-model="a1_3" v-on:change="updateValue('a1_3')"/></div>
              </div>
              <div class="row">
                <div class="col-11">Incarichi in società, associazioni, fondazioni, organizzazioni non lucrative, organizzazioni non governative soprattutto se aventi sede in paesi ad alto rischio o non collaborativi<hr></div>
                <div class="col-1">
                  <input type="checkbox" v-model="a1_4" v-on:change="updateValue('a1_4')"/>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Processi penali o indagini in corso per circostanze attinenti al terrorismo, al riciclaggio o all’autoriciclaggio – Misure di prevenzione o provvedimenti di sequestro - Familiarità/stretti legami con soggetti sottoposti a indagini o a procedimenti penali o provvedimenti di sequestro o censiti nelle liste delle persone o degli enti attivi nel finanziamento del terrorismo[1]<hr></div>
                <div class="col-1">
                  <input type="checkbox" v-model="a1_5" v-on:change="updateValue('a1_5')"/>
                </div>
              </div>
              <div class="row">
                <div class="col-11">Altro</div>
                <div class="col-1">
                  <input type="checkbox" v-model="a1_6" v-on:change="updateValue('a1_6')"/>
                </div>
              </div>
            </td>
            <td>{{valore_natura_giuridicaA1}}</td>
          </tr>
          <tr>
            <td>Prevalente attività svolta</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Attività esposte al rischio di infiltrazioni criminali e terroristiche secondo le periodiche pubblicazioni delle Autorità in materia, sia a livello sovranazionale (Relazione UE sulla valutazione del rischio sovranazionale), sia a livello nazionale (triennale: “Analisi nazionale dei rischi di riciclaggio e finanziamento del terrorismo” MEF/CSF e annuale: “Rapporto annuale dell’Unità di Informazione Finanziaria” UIF/Bankitalia nonché la Relazione annuale al Parlamento del MEF)<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="a2_1" v-on:change="updateValue('a2_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Struttura organizzativa e dimensionale non coerente con l’attività svolta<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="a2_2" v-on:change="updateValue('a2_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Non conformità dell’attività svolta rispetto a quella indicata nell’atto costitutivo<hr></div>
                  <div class="col-1"> <input type="checkbox" v-model="a2_3" v-on:change="updateValue('a2_3')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="a2_4" v-on:change="updateValue('a2_4')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_attivita_prevalente_svoltaA2}}</td>
          </tr>
          <tr>
            <td>Comportamento tenuto al momento del conferimento dell’incarico</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Cliente non presente fisicamente<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="a3_1" v-on:change="updateValue('a3_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Presenza di soggetti terzi con ruolo non definito<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="a3_2" v-on:change="updateValue('a3_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Comportamento non trasparente e collaborativo<hr></div>
                  <div class="col-1"> <input type="checkbox" v-model="a3_3" v-on:change="updateValue('a3_3')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Difficoltà nell’individuazione del titolare effettivo<hr></div>
                  <div class="col-1">
                    <input type="checkbox" v-model="a3_4" v-on:change="updateValue('a3_4')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="a3_5" v-on:change="updateValue('a3_5')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_comportamento_tenutoA3}}</td>
          </tr>
          <tr>
            <td>Area geografica di residenza del cliente</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Residenza/localizzazione in : comune italiano a rischio a causa dell’utilizzo eccessivo di contante – Residenza in Paesi terzi ad alto rischio individuati dalle Autorità – Paesi terzi non dotati di efficaci sistemi di prevenzione del riciclaggio e del finanziamento del terrorismo coerenti con le raccomandazioni del GAFI – Paesi terzi caratterizzati da un elevato livello di corruzione o di permeabilità ad altre attività criminose – Aree di conflitto in cui sono presenti organizzazioni terroristiche o in zone limitrofe o di transito – Paese soggetto a sanzioni o embarghi o misure analoghe stabilite dall’O.N.U. o altri organismi internazionali - (vedasi le pubblicazioni periodiche delle Autorità in materia, sia a livello sovranazionale, sia a livello nazionale)<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="a4_1" v-on:change="updateValue('a4_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Lontananza della residenza del cliente rispetto alla sede del professionista<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="a4_2" v-on:change="updateValue('a4_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="a4_3" v-on:change="updateValue('a4_3')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_areageografica_residenzaA4}}</td>
          </tr>
        </tbody>
      </table>
    </card>
    <!-- TABELLA B-->
     <card class="card">
      <label style="color:black; font-size:18px;font-weight:bold">B. Aspetti connessi all’operazione e/o prestazione professionale<input type="checkbox" v-model="showTableB" style="margin-left:10px"></label>
      <table class="table tablesorter" id="tabella" style="text-align: center" v-show="showTableB">
        <thead>
          <tr>
            <th></th>
            <th>Fattore di rischio riscontrato</th>
            <th>Valore</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tipologia  (barrare i fattori riscontrati)</td>
            <td style="text-align:left">
              <div class="row">
                <div class="col-11">Operazione ordinaria/straordinaria rispetto al profilo soggettivo del cliente<hr></div>
                <div class="col-1"><input type="checkbox" v-model="b1_1" v-on:change="updateValue('b1_1')"/></div>
              </div>
              <div class="row">
                <div class="col-11">Operazione che prevede schemi negoziali che possono agevolare l’opacità delle relazioni economiche e finanziarie intercorrenti tra il cliente e la controparte<hr></div>
                <div class="col-1"><input type="checkbox" v-model="b1_2" v-on:change="updateValue('b1_2')"/></div>
              </div>
              <div class="row">
                <div class="col-11">Articolazione contrattuale ingiustificata<hr></div>
                <div class="col-1"> <input type="checkbox" v-model="b1_3" v-on:change="updateValue('b1_3')"/></div>
              </div>
              <div class="row">
                <div class="col-11">Altro</div>
                <div class="col-1">
                  <input type="checkbox" v-model="b1_4" v-on:change="updateValue('b1_4')"/>
                </div>
              </div>
            </td>
            <td>{{valore_tipologiaB1}} </td>
          </tr>
          <tr>
            <td>Modalità di svolgimento </td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Utilizzo di mezzi di pagamento non tracciati - Utilizzo di valute virtuali<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b2_1" v-on:change="updateValue('b2_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Utilizzo di conti non propri per trasferire/ricevere fondi<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b2_2" v-on:change="updateValue('b2_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Ricorso reiterato a procure<hr></div>
                  <div class="col-1"> <input type="checkbox" v-model="b2_3" v-on:change="updateValue('b2_3')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Ricorso a domiciliazioni di comodo<hr></div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b2_4" v-on:change="updateValue('b2_4')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b2_5" v-on:change="updateValue('b2_5')"/>
                  </div>
                </div>
            </td>
            <td> {{valore_modalita_svolgimentoB2}}</td>
          </tr>
          <tr>
            <td>Ammontare dell’operazione</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Incoerenza dell’ammontare rispetto al profilo economico e finanziario del cliente<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b3_1" v-on:change="updateValue('b3_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Presenza di frazionamenti artificiosi<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b3_2" v-on:change="updateValue('b3_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b3_3" v-on:change="updateValue('b3_1')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_ammontareB3}}</td>
          </tr>
          <tr>
            <td>Frequenza e volume delle operazioni/durata della prestazione professional</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Non congruità della frequenza dell’operazione rispetto all’attività esercitata – Operatività improvvisa e poco giustificata rispetto all’ordinaria attività – Operazioni di ammontare consistente, concentrate in un ristretto arco temporale<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b4_1" v-on:change="updateValue('b4_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Rapporto professionale continuativo o occasionale<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b4_2" v-on:change="updateValue('b4_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b4_3" v-on:change="updateValue('b4_3')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_frequenza_durataB4}}</td>
          </tr>
          <tr>
            <td>Ragionevolezza</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Irragionevolezza dell’operazione rispetto all’attività svolta dal cliente<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b5_1" v-on:change="updateValue('b5_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Irragionevolezza dell’operazione rispetto all’entità delle risorse economiche nella disponibilità del cliente<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b5_2" v-on:change="updateValue('b5_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Non congruità dell’operazione rispetto alle finalità dichiarate<hr></div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b5_3" v-on:change="updateValue('b5_3')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b5_4" v-on:change="updateValue('b5_4')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_ragionevolezzaB5}}</td>
          </tr>
          <tr>
            <td>Area geografica di destinazione Fattore di rischio riscontrato DA MAPPA DELLE PROVINCIE CON 4 LIVELLI DI RISCHIO)</td>
            <td style="text-align:left">
              <div class="row">
                  <div class="col-11">Destinazione in : comune italiano a rischio a causa dell’utilizzo eccessivo di contante – Paesi terzi ad alto rischio individuati dalle Autorità – Paesi terzi non dotati di efficaci sistemi di prevenzione del riciclaggio e del finanziamento del terrorismo coerenti con le raccomandazioni del GAFI – Paesi terzi caratterizzati da un elevato livello di corruzione o di permeabilità ad altre attività criminose – Aree di conflitto in cui sono presenti organizzazioni terroristiche o in zone limitrofe o di transito – Paese soggetto a sanzioni o embarghi o misure analoghe stabilite dall’O.N.U. o altri organismi internazionali - (vedasi le pubblicazioni periodiche delle Autorità in materia, sia a livello sovranazionale, sia a livello nazionale)<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b6_1" v-on:change="updateValue('b6_1')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Inesistenza di riferimenti tradizionali nell’area geografica di destinazione (ad es. assenza di organismi equivalenti alle Camere di Commercio che detengono registri pubblici)<hr></div>
                  <div class="col-1"><input type="checkbox" v-model="b6_2" v-on:change="updateValue('b6_2')"/></div>
                </div>
                <div class="row">
                  <div class="col-11">Irragionevolezza e non congruità della ricerca di interazione con altre aree geografiche (ad es. vendita di determinati prodotti in aree geografiche nelle quali notoriamente gli stessi non risultano utilizzati)<hr></div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b6_3" v-on:change="updateValue('b6_3')"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-11">Altro</div>
                  <div class="col-1">
                    <input type="checkbox" v-model="b6_4" v-on:change="updateValue('b6_4')"/>
                  </div>
                </div>
            </td>
            <td>{{valore_areageografica_destinazioneB6}}</td>
          </tr>
        </tbody>
      </table>
    </card>
    
    <!-- <card class="card">
      
    </card> -->
    <card>
      <div class="row" style="color:black;margin-top:20px">
        <div class="col-4">
          <button class="btn" v-on:click="computeTotal()" style="margin-bottom:20px;background:green">Calcola totale</button>
        </div>
        <div class="col-8" style="text-align:left">
          <div v-show="showTotal">
            <div v-if="showTableB">
              <p style="color:black">Totale A ({{totaleA}}) + Totale B ({{totaleB}})  =  {{totale}}  :  10  =  {{totale/10}}</p>
            </div>
            <div v-else>
              <p style="color:black">Totale A ({{totaleA}}) :  4  =  {{totaleA/4}}</p>
            </div>
            <p style="color:black">Considerato il punteggio calcolato il livello di rischio specifico è classificaile come <span v-bind:style="{background: color}"> {{significativo}}</span> significativo</p>
          </div>
        </div>
      </div>
      <form>
        <div class="form-row">
          <div class="form-group col-md-4">
              <label for="dataVerifica">Data Verifica</label>
              <input type="date" class="form-control" v-model="dataVerifica">
          </div>
          <div class="form-group col-md-4">
            <label for="utente">Utente</label>
              <input type="text" class="form-control" v-model="utente">
          </div>
          <div class="form-group col-md-4">
            <button class="btn float-center" type="button" v-on:click="salvaValori()" style="margin-top: 20px;background:#00467f">Salva</button>
          </div>
        </div>
      </form>
    </card>
    <!-- <div class="row">
      <div class="col" style="margin-top:5px;margin-bottom:20px">
        <p style="font-size:13px;text-align:center;margin-top:10px;color:black">Data Verifica <input type="date" v-model="dataVerifica" style="margin-right:20px">
        Utente <input type="text" style="margin-left:10px"></p>
      </div>
      <div class="col"><button class="btn float-center" type="button" v-on:click="salvaValori()" style="margin-top: 10px;background:#00467f">Salva</button></div>
    </div> -->
    <!-- -->
    <card class="card" style="margin-top:10px">
      <div class="row">
        <div class="col-5">
          <div style="border: 1px solid">
            <p style="font-size:14px;margin-right:20px;margin-left:20px;margin-top:10px;color:black">
              Punteggi da indicare per la determinazione del rischio<br>
              1 = minimo <br>
              4 = massimo
            </p>
          </div> 
        </div>
        <div class="col-7">
          <div style="border: 1px solid">
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;margin-bottom:5px;margin-top:10px">
              <strong>Grado di rischio</strong>
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;background:#9ACD32">
              NON SIGNIFICATIVO
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;background:#FFFF00">
              POCO SIGNIFICATIVO
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;background:#FFA500">
              ABBASTANZA
            </div>
            <div style="border: 1px solid;margin-right:150px;margin-left:150px;text-align:center;margin-bottom:10px;background:#FF0000">
              MOLTO SIGNIFICATIVO
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
/*import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import UserCard from "./UserProfile/UserCard.vue";
import MembersCard from "./UserProfile/MembersCard.vue";
import Button from '../components/Button.vue';*/
import Card from '@/components/Cards/Card.vue';
// import Card from '../../components/Cards/Card.vue';
export default {
  components: {
    /*EditProfileForm,
    UserCard,
    MembersCard,
    Button*/
    Card
  },

  data() {
    return {
      a1_1: false, a1_2: false, a1_3: false, a1_4: false, a1_5: false, a1_6: false,
      valore_natura_giuridicaA1: 1,
      
      a2_1: false, a2_2: false, a2_3: false, a2_4: false,
      valore_attivita_prevalente_svoltaA2: 1,
      
      a3_1: false, a3_2: false, a3_3: false, a3_4: false, a3_5: false,
      valore_comportamento_tenutoA3: 1,
     
      a4_1: false, a4_2: false, a4_3: false,
      valore_areageografica_residenzaA4: 1,
     
      showTableB: false,
      b1_1: false, b1_2: false, b1_3: false, b1_4: false,
      valore_tipologiaB1: 1,

      b2_1: false, b2_2: false, b2_3: false, b2_4: false, b2_5: false,
      valore_modalita_svolgimentoB2: 1,
      
      b3_1: false, b3_2: false, b3_3: false,
      valore_ammontareB3: 1,

      b4_1: false, b4_2: false, b4_3: false,
      valore_frequenza_durataB4: 1,
     
      b5_1: false, b5_2: false, b5_3: false,b5_4: false, b5_5: false, b5_6: false,
      valore_ragionevolezzaB5: 1,

      b6_1: false, b6_2: false, b6_3: false,b6_4: false,
      valore_areageografica_destinazioneB6: 1,

      totaleA : 0,
      totaleB: 0,
      totale: 0,
      showTotal: false,
      significativo: 'NON',
      color: '',
      dataVerifica: null,
    }
  },

  methods: {
    updateValue: function(value) {
      value = value.substring(0,2);
      console.log("value: " + value);
      let array = [];
      let counter = 0;
      switch (value) {
        case "a1":
          counter = 0;
          array = [ this.a1_1, this.a1_2, this.a1_3, this.a1_4, this.a1_5, this.a1_6];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_natura_giuridicaA1 = 1;
          } else if (counter == 1) {
            this.valore_natura_giuridicaA1 = 2;
          } else if (counter == 2 ) {
            this.valore_natura_giuridicaA1 = 3;
          }  else {
            this.valore_natura_giuridicaA1 = 4;
          }
          break;
        case "a2":
          counter = 0;
          array = [ this.a2_1, this.a2_2, this.a2_3, this.a2_4];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_attivita_prevalente_svoltaA2 = 1;
          } else if (counter == 1) {
            this.valore_attivita_prevalente_svoltaA2 = 2;
          } else if (counter == 2) {
            this.valore_attivita_prevalente_svoltaA2 = 3;
          }  else {
            this.valore_attivita_prevalente_svoltaA2 = 4;
          }
          break;
        case "a3":
          counter = 0;
          array = [ this.a3_1, this.a3_2, this.a3_3, this.a3_4, this.a3_5];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_comportamento_tenutoA3 = 1;
          } else if (counter == 1) {
            this.valore_comportamento_tenutoA3 = 2;
          } else if (counter == 2) {
            this.valore_comportamento_tenutoA3 = 3;
          }  else {
            this.valore_comportamento_tenutoA3 = 4;
          }
          break;
        case "a4":
          array = [ this.a4_1, this.a4_2, this.a4_3];
          counter = 0;
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_areageografica_residenzaA4 = 1;
          } else if (counter == 1) {
            this.valore_areageografica_residenzaA4 = 2;
          } else if (counter == 2) {
            this.valore_areageografica_residenzaA4 = 3;
          }  else {
            this.valore_areageografica_residenzaA4 = 4;
          }
          break;
        case "b1":
          counter = 0;
          array = [ this.b1_1, this.b1_2, this.b1_3, this.b1_4];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_tipologiaB1 = 1;
          } else if (counter == 1) {
            this.valore_tipologiaB1 = 2;
          } else if (counter == 2) {
            this.valore_tipologiaB1 = 3;
          }  else {
            this.valore_tipologiaB1 = 4;
          }
          break;
        case "b2":
          counter = 0;
          array = [ this.b2_1, this.b2_2, this.b2_3, this.b2_4, this.b2_5];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_modalita_svolgimentoB2 = 1;
          } else if (counter == 1) {
            this.valore_modalita_svolgimentoB2 = 2;
          } else if (counter == 2) {
            this.valore_modalita_svolgimentoB2 = 3;
          }  else {
            this.valore_modalita_svolgimentoB2 = 4;
          }
          break;
        case "b3":
          counter = 0;
           array = [ this.b3_1, this.b3_2, this.b3_3 ];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_ammontareB3 = 1;
          } else if (counter == 1) {
            this.valore_ammontareB3 = 2;
          } else if (counter == 2) {
            this.valore_ammontareB3 = 3;
          }  else {
            this.valore_ammontareB3 = 4;
          }
          break;
        case "b4":
          counter = 0;
          array = [ this.b4_1, this.b4_2, this.b4_3 ];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_frequenza_durataB4 = 1;
          } else if (counter == 1) {
            this.valore_frequenza_durataB4 = 2;
          } else if (counter == 2) {
            this.valore_frequenza_durataB4 = 3;
          }  else {
            this.valore_frequenza_durataB4 = 4;
          }
          break;
        case "b5":
          counter = 0;
          array = [ this.b5_1, this.b5_2, this.b5_3, this.b5_4 ];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_ragionevolezzaB5 = 1;
          } else if (counter == 1) {
            this.valore_ragionevolezzaB5 = 2;
          } else if (counter == 2) {
            this.valore_ragionevolezzaB5 = 3;
          }  else {
            this.valore_ragionevolezzaB5 = 4;
          }
          break;
        case "b6":
          counter = 0;
          array = [ this.b6_1, this.b6_2, this.b6_3, this.b6_4 ];
          for (let i = 0; i < array.length; i++) {
            if (array[i] == true) {
              counter++;
            }
          }
          if (counter == 0) {
            this.valore_areageografica_destinazioneB6 = 1;
          } else if (counter == 1) {
            this.valore_areageografica_destinazioneB6 = 2;
          } else if (counter == 2) {
            this.valore_areageografica_destinazioneB6 = 3;
          }  else {
            this.valore_areageografica_destinazioneB6 = 4;
          }
          break;
      }
    },

    computeTotal: function() {
      let tot = 0;
      this.showTotal = true;
      this.totaleA = this.valore_natura_giuridicaA1 + this.valore_attivita_prevalente_svoltaA2 + this.valore_comportamento_tenutoA3 + this.valore_areageografica_residenzaA4;
      this.totaleB = this.valore_tipologiaB1 + this.valore_modalita_svolgimentoB2 + this.valore_ammontareB3 + this.valore_frequenza_durataB4 + this.valore_ragionevolezzaB5 + this.valore_areageografica_destinazioneB6;
      if (this.showTableB) {
        this.totale = this.totaleA + this.totaleB;
        tot = this.totale/10;
      } else {
        this.totale = this.totaleA;
        tot = this.totale/4;
      }
      // background:#9ACD32, background:#FFFF00 background:#FFA500  background:#FF0000
      if (tot  >= 1 && tot <= 1.5) {
        console.log("here");
        this.significativo = 'NON';
        this.color = '#9ACD32';
      } else if (tot  >= 1.6 && tot <= 2.5) {
        this.significativo = 'POCO';
        this.color = '#FFFF00';
      } else if (tot >= 2.6 && tot <= 3.5) {
        this.significativo = 'ABBASTANZA';
        this.color = '#FFA500';
      } else {
        console.log("tot: " + tot);
        this.significativo = 'MOLTO';
        this.color = '#FF0000';
      }
    },

    caricaValori: async function() {
      if (this.dataVerifica == null) {
        this.dataVerifica = new Date();
      }
    },

    salvaValori: async function() {
      /* 
        var TAB_A={ A1:4, A2:3, A3:1, A4:4, DATI:[ {A1_1:false,A1_2:true}, {A2_1:true,A2_2:false}]}
      */
      let datiA = [
        { B1_1: this.b1_1, B1_2: this.b1_2, B1_3: this.b1_3, B1_4: this.b1_4  },
        { B2_1: this.b2_1, B2_2: this.b2_2, B2_3: this.b2_3, B2_4: this.b2_4, B2_5: this.b2_5 },
        { B3_1: this.b3_1, B3_2: this.b3_2, B3_3: this.b3_3 },
        { B4_1: this.b4_1, B4_2: this.b4_2, B4_3: this.b4_3 },
        { B5_1: this.b5_1, B5_2: this.b5_2, B5_3: this.b5_3, B5_4: this.b5_4 },
        { B6_1: this.b6_1, B6_2: this.b6_2, B6_3: this.b6_3, B6_4: this.b6_4 },
      ]
      let TAB_A = {
        A1: this.valore_natura_giuridicaA1, A2: this.valore_attivita_prevalente_svoltaA2, A3: this.valore_comportamento_tenutoA3, A4: this.valore_areageografica_residenzaA4, DATI: datiA
      }

      let datiB = [
        { A1_1: this.a1_1, A1_2: this.a1_2, A1_3: this.a1_3, A1_4: this.a1_4, A1_5: this.a1_5, A1_6: this.a1_6 },
        { A2_1: this.a2_1, A2_2: this.a2_2, A2_3: this.a2_3, A2_4: this.a2_4 },
        { A3_1: this.a3_1, A3_2: this.a3_2, A3_3: this.a3_3, A3_4: this.a3_4, A3_5: this.a3_5 },
        { A4_1: this.a4_1, A4_2: this.a4_2, A4_3: this.a4_3 }
      ]
      let TAB_B = {
        B1: this.valore_tipologiaB1, B2: this.valore_modalita_svolgimentoB2, B3: this.valore_ammontareB3, B4: this.valore_frequenza_durataB4, B5: this.valore_ragionevolezzaB5, B6: this.valore_areageografica_destinazioneB6, DATI: datiB
      }
    },

    dateToday: function() {
      let data = new Date(); 
      // console.log("data " + data);
      let gg, mm, aaaa; 
      gg = data.getDate() + "/"; 
      mm = data.getMonth() + 1 + "/"; 
      aaaa = data.getFullYear(); 
      //document.write("Oggi è il " + gg + mm + aaaa)
      // console.log("Oggi è il " + gg + mm + aaaa);
      return data;
    },
    
    main: function() {
      this.dateToday();
    }
  },
  mounted() {
        this.main();
    } 
};
</script>
<style>

  div{
    font-size:16px
  }

  .button {
    background-color: #4CAF50;
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
  }

  td{
    font-size:14px,
  }
  th {
    font-size:16px,
  }
</style>
